import { HTMLProps } from "react"
import { link } from "./style.css"

type Props = HTMLProps<HTMLAnchorElement>

function Link(props: Props) {
  return (
    <a {...props} className={link}>
      {props.children}
    </a>
  )
}

export default Link
